import { getDomainUrl } from 'core/utils';

export const userProfilePath = () => '/user/profile';
export const companySettingsPath = () => '/company/settings';

const domainUrl = getDomainUrl();

export const oldOldHomePath = () => `${domainUrl}/home`;
export const oldUserProfilePath = () => `${domainUrl}/user/profile`;
export const oldCompanySettingsPath = () => `${domainUrl}/company/settings`;
export const oldReportsPath = () => `${domainUrl}/report/quote-list`;
